import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import { actionHandler, stepHasRequiredData } from '../../../utilities/form/formUtils';
import { sendTrygTealium } from '../../../utilities/tracking';

// Components
import Text from '../../Global/Text';

class Button extends Component {
  constructor(props) {
    super(props);
    this.setButton = this.setButton.bind(this);
    this.state = {
      active: false,
    };
  }

  setButton() {
    const { active } = this.state;
    this.setState({
      active: !active,
    });
  }

  render() {
    const { active } = this.state;
    const {
      id,
      label,
      actions,
      dispatch,
      variant,
      values,
      columns,
      type,
      tracking,
      requiredData,
      userData,
      inline,
      subType,
      setValues,
      className,
      dataTealium,
      additionalClassName,
      submitIcon,
      continueOnEnter,
      translations,
      trackingStepNo,
      trackingCondition,
    } = this.props;
    const isDisabled = !stepHasRequiredData(requiredData, userData, values);

    const formFieldClass = classNames(
      'form__field', {
        'form__field--active': active,
        [`form__field--${id}`]: id,
        [`form__field--${type}`]: type,
        [`form__field--${type}-${variant}`]: type && variant,
        [`form__field--${columns}col`]: columns,
        [`${className}`]: className !== '',
      }
    );

    const buttonClass = classNames(
      'button', {
        'button--disabled': isDisabled,
        'button--secondary': variant === 'button' && className === '',
        'button--primary': variant === 'button' && className !== '',
        [`button--${variant}`]: variant !== 'button',
        [`${additionalClassName}`]: additionalClassName !== '',
      },
      tracking
    );

    let btn = null;

    const keyChecker = (e) => {
      if (e.keyCode === 13 && btn != null && continueOnEnter) {
        btn.click();
      }
    };

    window.addEventListener('keyup', keyChecker);
    const newTrackingStepNo = trackingStepNo;
    if (newTrackingStepNo && !this.state.isTrackingSent) {
      let send = true;
      if (trackingCondition) {
        Object.keys(trackingCondition)
          .forEach(key => {
            if (userData[key] !== trackingCondition[key]) {
              send = false;
            }
          });
      }
      if (send) {
        sendTrygTealium(newTrackingStepNo, userData, translations);
        this.state.isTrackingSent = true;
      }
    }
    return (
      <div className={formFieldClass}>
        {inline &&
        <Text value={inline} component="span" className="button--inline"/>
        }
        <button
          type={subType}
          className={buttonClass}
          name={id}
          value={label}
          disabled={isDisabled}
          ref={node => (btn = node)} // eslint-disable-line no-param-reassign
          continueOnEnter={continueOnEnter}
          onClick={e => actionHandler(actions, this.setButton, e, dispatch, values, setValues)}
          data-tealium={dataTealium}
        >
          <Text value={label} submitIcon={submitIcon}/>
        </button>
      </div>
    );
  }
}

export default Button;

Button.defaultProps = {
  label: null,
  requiredData: null,
  values: null,
  tracking: ['tealiumSubmit'],
  variant: 'button',
  actions: [],
  userData: null,
  inline: null,
  className: '',
  subType: 'button',
  dataTealium: null,
  additionalClassName: '',
  submitIcon: false,
  continueOnEnter: false,
};

Button.propTypes = {
  id: PropTypes.string.isRequired,
  columns: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  values: PropTypes.object,
  type: PropTypes.string.isRequired,
  tracking: PropTypes.array,
  requiredData: PropTypes.object,
  actions: PropTypes.array,
  label: PropTypes.string,
  variant: PropTypes.string,
  userData: PropTypes.object,
  inline: PropTypes.string,
  setValues: PropTypes.func.isRequired,
  className: PropTypes.string,
  subType: PropTypes.string,
  dataTealium: PropTypes.string,
  additionalClassName: PropTypes.string,
  submitIcon: PropTypes.bool,
  continueOnEnter: PropTypes.bool,
  translations: PropTypes.string.isRequired,
  trackingStepNo: PropTypes.string.isRequired,
  trackingCondition: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Steps/General/Button.jsx